module.exports = __webpack_public_path__ + "img/news7-1.3dcdb4db.png";